import { Error, StylishLoading } from '@organisms/Feedbacks';
import { ListTable } from '@organisms/Tables';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

type TableColumnsProps = {
    Header: string;
    accessor: string;
    disableSortBy?: boolean;
    Cell?: object;
    width?: string;
};

type Props = {
    listData?: any;
};

const columnStyle = {
    linkButton: { color: 'black', fontSize: '12px', padding: '0.2rem 0.5rem', marginTop: '3px'},
    id: { minWidth: '50px', textAlign: 'right', whiteSpace: 'nowrap' },
    contactId: { width: '100px' },
    systemClassName: { width: '100px' },
    updateFlagName: { width: '100px' },
    powerCustomerLocationNumber: { width: '200px' },
    acceptStatusName: { minWidth: '100px', whiteSpace: 'nowrap' },
    // latestReceptionMessageStatusKbn: { width: '100px' },
    requestNo: { width: '125px' },
    relitRequestDate: { width: '100px' },
    relitDesiredDate: { width: '100px' },
    supplyStartDate: { width: '100px' },
    contractorName: { minWidth: '150px', whiteSpace: 'nowrap' },
    information: { width: '300px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' },
    latestReceptionMessage: { width: '300px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }
}

const openRequestColumn: TableColumnsProps[] = [
    { Header: '', accessor: 'linkButton', disableSortBy: true, Cell: ({ cell: { row, column } }: any) => createCell(row, column)  },
    { Header: 'ID', accessor: 'id', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '契約ID', accessor: 'contactId', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: 'システム', accessor: 'systemClassName', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '更新区分', accessor: 'updateFlagName', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '供給地点特定番号', accessor: 'powerCustomerLocationNumber', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '受付工程', accessor: 'acceptStatusName', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    // { Header: '警告未対応', accessor: 'latestReceptionMessageStatusKbn', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '申込番号', accessor: 'requestNo', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '再点依頼日', accessor: 'relitRequestDate', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '再点希望日', accessor: 'relitDesiredDate', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '供給開始日', accessor: 'supplyStartDate', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '契約者名', accessor: 'contractorName', disableSortBy: false, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '送配電からの連絡事項', accessor: 'information', disableSortBy: true, Cell: ({ cell: { row, column } }: any) => createCell(row, column) },
    { Header: '受付メッセージ', accessor: 'latestReceptionMessage', disableSortBy: true, Cell: ({ cell: { row, column } }: any) => createCell(row, column) }
];

const createCell = (row: any, column: any) => {
    const accessor = column.id;
    const rowDescriptor = Object.getOwnPropertyDescriptor(row.values, accessor);
    const value = rowDescriptor ? rowDescriptor.value : {};
    const styleDescriptor = Object.getOwnPropertyDescriptor(columnStyle, accessor);
    const cellStyle = Object.assign({ padding: '0.5em', height: '32px'}, styleDescriptor ? styleDescriptor.value : {});
    const buttonProparty = {
        variant: 'outline-light',
        wrapperStyle: { backgroundColor: 'transparent', height: '32px'},
        style: Object.assign({}, styleDescriptor ? styleDescriptor.value : {})
    };
    switch (row.original.acceptStatus) {
        case '00':
            buttonProparty.variant = 'warning';
            buttonProparty.style.color = 'white';
            buttonProparty.wrapperStyle.backgroundColor = '#fff3cd';
            cellStyle.backgroundColor = '#fff3cd';
            break;

        case '09':
        case '99':
            buttonProparty.variant = 'danger';
            buttonProparty.style.color = 'white';
            buttonProparty.wrapperStyle.backgroundColor = '#f8d7da';
            cellStyle.backgroundColor = '#f8d7da';
            break;
        default:
            buttonProparty.style.borderColor = '#6c757d';
    }
    return (
        accessor === 'linkButton' ?
            <div style={buttonProparty.wrapperStyle}>
                <Link key={row.values.id} to={`/open/detail/${row.values.id}`} style={{ display: 'block', width: '50px' }}>
                    <Button variant={buttonProparty.variant} size='sm' style={buttonProparty.style}>詳細</Button>
                </Link>
            </div>
        : accessor === 'powerCustomerLocationNumber' ?
            <div key={value} style={cellStyle}>
                <Link key={`${value}${row.values.id}`} to={`/facility/${value}`} style={cellStyle}>
                    {value}
                </Link>
            </div>
        // : accessor === 'latestReceptionMessageStatusKbn' && value === 'あり' ?
        //     <div key={value} style={cellStyle}>
        //         <WarningWithStyled>{value}</ WarningWithStyled>
        //     </div>
        :
            <div key={value} style={cellStyle}>
                {value}
            </div>
    );
}

const OpenTableList = (props: Props) => {
    const { listData } = props;
    const { data, error, loading } = listData;
    const relitList = data || [];

    return (
        <TableListWithStyled>
            <StylishLoading loading={loading}>
                {error && <Error />}
                {!error && data &&
                    <ListTable column={openRequestColumn} data={relitList} />
                }
            </StylishLoading>
        </TableListWithStyled>
    );
};

const TableListWithStyled = styled.div`
    overflow-x: hidden;
    & .table-wrapper {
        margin-bottom: 10px;
    }
    & .table {
        margin-bottom: 0;
    }
    & .table-bordered>:not(caption) td {
        padding: 0;
    }
    & .table-bordered>:not(caption) th {
        position: relative;
        padding-right: 0.8rem;
        & span {
            position: absolute;
            right: 2px;
        }
    }
`
const WarningWithStyled = styled.div`
    font-weight: bold;
    color: #dc3545;
`

export default OpenTableList;